"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PassiveCommitteeInfo = void 0;
var PassiveCommitteeInfo;
(function (PassiveCommitteeInfo) {
    PassiveCommitteeInfo[PassiveCommitteeInfo["NotInCommittee"] = 0] = "NotInCommittee";
    PassiveCommitteeInfo[PassiveCommitteeInfo["AddedButNotActiveInCommittee"] = 1] = "AddedButNotActiveInCommittee";
    PassiveCommitteeInfo[PassiveCommitteeInfo["AddedButWrongKeys"] = 2] = "AddedButWrongKeys";
})(PassiveCommitteeInfo = exports.PassiveCommitteeInfo || (exports.PassiveCommitteeInfo = {}));
